<template>
    <div class="inline">
        <div class="grid">
            <div class="form-item inline" valign="center">
                <label for="height_limit">Ограничение по высоте:</label>
                <input type="text" id="height_limit" class="text-input _small" v-model="data.max_height" /><span>см</span>
            </div>

            <div class="form-item">
                <label for="comments">Комментарий:</label>
                <textarea id="comments" v-model="data.comment"></textarea>
            </div>
            <div class="separator"></div>
            <div class="form-item radio">
                <div class="radio-item">
                    <input type="radio" id="motoplaces1" v-model="data.placing_on_cars" v-bind:value="false" />
                    <label for="motoplaces1">Только на местах для мото</label>
                </div>
                <div class="radio-item">
                    <input type="radio" id="motoplaces2" v-model="data.placing_on_cars" v-bind:value="true" />
                    <label for="motoplaces2">Мото может стоять на местах для авто</label>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="form-item">
                <label for="free_time">Бесплатное время:</label>
                <input type="text" id="free_time" class="text-input _small" v-model="data.free_time" />
            </div>

            <div class="form-item">
                <label for="cancel_time">Время отмены:</label>
                <input type="text" id="cancel_time" class="text-input _small" v-model="data.cancel_time" />
            </div>

            <div class="form-item">
                <label for="moto_count">Число мест (мото):</label>
                <div class="inline">
                    <input type="text" id="moto_count" class="text-input _small" v-model="data.cnt_moto_parkings" />
                    <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'parking', id: data.id, field: 'bk_parking_moto_spots_count'})"></div>
                </div>
            </div>
            <div class="form-item">
                <label for="total_places">Число мест (авто):</label>
                <div class="inline">
                    <input type="text" id="total_places" class="text-input _small" v-model="data.cnt_parkings" />
                    <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'parking', id: data.id, field: 'bk_parking_spots_count'})"></div>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="form-item">
                <label for="percent">Процент парковщика:</label>
                <div class="inline">
                    <input type="text" id="percent" class="text-input _small" v-model="data.parking_percent" />
                    <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'parking', id: data.id, field: 'bk_parking_percent'})"></div>
                </div>
            </div>
            <div class="text-item" v-if="data.units_car">
                <span>Кол-во в слоте (авто):</span>
                <p class="_small">{{ data.units_car }}</p>
            </div>
            <div class="text-item" v-if="data.units_moto">
                <span>Кол-во в слоте (мото):</span>
                <p class="_small">{{ data.units_moto }}</p>
            </div>
        </div>
        <div class="grid">
            <h3 v-show="data.units">Кол-во на 1 ТС</h3>
            <div class="form-item"  v-for="(item, index) of data.units" :key="index">
                <label :for="'units' + index">{{ item.car_type }}:</label>
                <input type="text" :id="'units' + index" class="text-input _small" v-model="item.value" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>